export default "__VITE_ASSET__DzHLjoaU__"